import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { FormFieldModule } from '../form-field/form-field.module';
import { ComboboxFieldComponent } from './combobox-field.component';

@NgModule({
    declarations: [
        ComboboxFieldComponent,
    ],
    imports: [
        CommonModule,
        FormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
    ],
    exports: [
        ComboboxFieldComponent,
    ],
    providers: [],
})
export class ComboboxFieldModule {}
